import type { IBaseItem } from '@shiftsmartinc/shiftsmart-types';

import _ from 'lodash';

import BaseStore from './_baseStore';

export type IPaymentAdjustmentUploader = IBaseItem & Record<string, unknown>;

export default class PaymentAdjustmentUploaderStore extends BaseStore<IPaymentAdjustmentUploader> {
  constructor() {
    const baseItem = { csvFile: '' };
    super({ baseItem, serviceName: 'paymentAdjustmentUploader' });

    this.selected = _.clone(this.baseItem);

    return this;
  }
}
